import { Box, Checkbox, Flex, RadioButton } from '@gmg/gmg-react-components';
import { FunctionComponent, useState } from 'react';
import { ModuleId, MODULEID_TO_EDITION_NAME as idToEditionName } from 'src/graphql/mappers/module';
import { SingleModule } from './ModuleSelector';

export interface ModuleSelectorProps {
    moduleWithOptions: {
        productName: string;
        modules: Array<SingleModule>;
    };
    onSelectModule: (value: ModuleId) => void;
};

// The ModuleSelectorWithOptions component manages an internal state to control:
// 1. The Checkbox's checked state
// 2. The initial selection of the first option
// To keep the module state in sync with the parent component, we use getter and setter functions
// when the checkbox is clicked.
const ModuleSelectorWithOptions: FunctionComponent<ModuleSelectorProps> = ({ moduleWithOptions, onSelectModule }) => {

    const [selectedOption, setSelectedOption] = useState<ModuleId | undefined>(moduleWithOptions.modules.find(o => o.isModuleAssignedToUser)?.id);

    return (
        <Flex flexDirection='column' gap='8px' zIndex='100'>
            <Checkbox
                aria-label={moduleWithOptions.productName}
                id={moduleWithOptions.productName}
                label={moduleWithOptions.productName}
                checked={selectedOption !== undefined}
                onChange={() => {
                    if (selectedOption) {
                        onSelectModule(selectedOption);
                        setSelectedOption(undefined);
                    } else {
                        const notDisabledOptions = moduleWithOptions.modules.filter(m => !m.isDisabled);
                        setSelectedOption(notDisabledOptions[0].id);
                        onSelectModule(notDisabledOptions[0].id);
                    }
                }}
            />

            {moduleWithOptions.modules.map(option => {
                return (
                    <Flex flexDirection='row' pl='24px' key={option.id} alignItems='center'>
                        <RadioButton
                            aria-label={option.name}
                            key={option.id}
                            id={option.name}
                            label={idToEditionName.get(option.id)!}
                            value={option.id}
                            checked={selectedOption === option.id}
                            disabled={option.isDisabled}
                            onChange={(ev: any) => {
                                if (option.isDisabled) return;
                                onSelectModule(ev.target.value);
                                setSelectedOption(ev.target.value);
                            }}
                        />
                        <Box
                            pl='24px'
                            className='px10_400_weak'
                            aria-label={`additional module info for ${option.name}`}
                        >
                            {option.moduleInfo}
                        </Box>
                    </Flex>
                );
            })}
        </Flex>
    );
};

export default ModuleSelectorWithOptions;